module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter One")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("B")])]), _vm._v("ethany Paxton went completely still, holding her breath when she felt the whisper of her husband’s warm, mint-scented breath brush her cheek, then the press of his mouth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Feel better, baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wanted to tell him there was no way she would ever feel better—not when she had been forced to play stepmother to a teenager who had to have been the devil’s spawn. Her ultraconservative Bible belt parents had lectured her over and over about using the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hate,")]), _vm._v(" but she could truly say that she hated her husband’s fifteen-year-old daughter. The bitch-in-training went out of her way to work Bethany into a frenzy wherein she’d seriously considered murdering the girl.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("One time when she was slicing fruit for a salad, she’d gripped the handle of the knife and had been ready to plunge it into Paige’s heart. The thought was so shocking that Bethany called her twin brother, telling him of her wicked thoughts, and he was able to talk her off the proverbial ledge.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Later that night, Bethany downed a bottle of wine, went to sleep and didn’t wake up until her children roused her, crying that if she didn’t get up they were going to be late for school. Now when she drank herself into a stupor it didn’t matter whether she got out of bed or not. That’s what live-in housekeepers were for. As hired help, the woman got up early and made certain her son and daughter were washed, dressed and fed breakfast before she walked them to the corner to wait for the school bus.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At first Damon had balked at hiring a housekeeper when a cleaning service came in twice a week to clean, dust, vacuum and do the laundry, but Bethany did what she hadn’t done since she’d first laid eyes on Damon Paxton sitting at a table in an upscale D.C. restaurant more than ten years ago. She had seduced him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Twenty years his junior, Bethany offered Damon the best sex he’d ever had in his life. It hadn’t mattered that he’d been married with a young child. She’d wanted Damon, and after a torrid affair and an uncontested divorce wherein Damon had given his wife a sizable settlement, Bethany had married her prince.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Opening one eye, she squinted at the clock on the bedside table. It was almost eight, and that meant in another hour she would be alone—alone to think about the turn her life had taken. She was only thirty-five but felt years older. She was drinking much too much, and the result was she’d gained weight and the skin under her eyes was puffy.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("As Mrs. Damon Paxton she’d found herself isolated, snubbed by the wives of her husband’s business associates, which initially led Bethany to doubt her attractiveness and femininity. However, when rumors surfaced that she was a tramp and home wrecker she realized it had been retribution. The first Mrs. Paxton was D.C. royalty, and Bethany was ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("a former beauty queen who had grown up in an Alabama trailer park. Only within the privacy of her bedroom did she feel confident enough to ensure her marriage was on solid footing.")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Turning over and staring up at the gossamer fabric draping the antique canopy bed, Bethany knew she couldn’t continue the pretense that she had the perfect life and the perfect marriage. If she were truly honest, she would admit that both were in the toilet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Something had to change; something had to give; she had to change or she would end up like her mother, who’d looked seventy at forty, was depressed, broken and had been dead a week before her body was discovered when a neighbor called the police after she’d noticed a strange odor coming from the adjoining apartment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her parents had moved out of the trailer and into a one-bedroom apartment once all their children had left home. Her dad had gone to West Virginia to visit his sister, who’d been hospitalized with a terminal illness, when he was notified that his wife had died from natural causes. It had been the last time Bethany had visited Parkers Corner.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bethany sat up, opened the drawer to the bedside table and removed a cloth-covered journal and pen. Flipping to a blank page, she jotted down a list of things she needed to do: Diet. Call dermatologist about Botox. Contact personal trainer. She closed the book, picked up her cell phone, scrolled through her directory and tapped the button for her dermatologist, leaving a voice-mail message for someone to return her call. Minutes later she confirmed a session with her longtime personal trainer.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Dieting was easy. All she had to do was drink more water, increase daily portions of fruits and vegetables and limit eating red meat to twice a week. She would give herself two ")]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("weeks of dieting and exercise before emerging from what had become a period of self-isolation. Damon’s social secretary had called her with an update of his calendar and Bethany would call Caroline and let her know to which of the events she would accompany her husband.")])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Swinging her legs over the side of the bed, she walked from the bedroom to her en suite bath. One thing she had insisted on when she and Damon had gone house hunting: she had to have her own bathroom. Living in a double-wide with six other people and one bathroom had scarred Bethany for life. She could never linger more than three minutes because someone was always knocking on the door. What family members didn’t know was the bathroom had become her sanctuary—a place that in her imagination had become a magical place where she as a princess waited for her prince to come and rescue her from the squalor, poverty and the ridicule of other kids who constantly reminded Bethany that she was wearing her older sister’s hand-me-downs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But that all changed as her body filled out. Boys had begun to notice her long legs, natural wavy flaxen hair, luminous violet eyes framed by long charcoal-gray lashes and her seductive smile that never failed to elicit gasps from the opposite sex. It had taken hours of practicing in front of the bathroom mirror before Bethany was able to lower her eyelids, tilt her head at an angle and peer up at a man through her lashes to get him to do whatever she wanted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v("Her smile, body and face had been her ticket out of the tiny mill town and into the spotlight as beauty queen, soap opera actress and news correspondent. When she was assigned to cover a newly elected representative from her home state, her life had changed forever. It was her first visit to the nation’s capital and the first time she came face-to-face with Damon Paxton. As one of D.C.’s most influential lobbyists, Damon ")]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("was purported to be as powerful as any man, past or present, who’d occupied the Oval Office.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bethany stared at her reflection in the mirrors above the counter that created an illusion of infinite space. Pale ash cabinetry and a raised one-step from the vanity area functioned as a dressing room; a water closet and low tub were screened by sliding ash doors fitted with light-filtering frosted glass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her bathroom had become her retreat when she closed and locked the door, shutting out the constant bickering between her son and daughter and Damon when he went on incessantly about up-and-coming politicos and veteran elected officials whom he’d sought to bring into his sphere of influence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was no wonder she’d begun drinking. It was either booze or drugs. Even when her college friends were smoking marijuana and/or snorting cocaine, Bethany had never been one to experiment, because she feared becoming addicted like her father, who had become hooked on painkillers after he’d broken his back when he’d slipped on a wet floor at the garage where he’d worked as a mechanic. He’d tried suing the owner, but lost his case because he’d neglected to wipe up the oil that had been leaking from the car he’d been working on. Her father was forced to retire and wound up on welfare with a Medicaid card and food stamps.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And she didn’t need a therapist to tell her why she had begun drinking more than usual. It was because of Damon’s daughter Paige. It was as if the girl existed solely to disrupt her father’s marriage and to make their lives a living hell. Beth knew the girl blamed her for breaking up her father and mother’s marriage. What Paige hadn’t known was that her parents’ marriage had been over for years.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("Opening a drawer under the counter, Bethany took out a jar of cleansing cream her dermatologist had recommended to offset the dry, red patches that occurred whenever she ")]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("used soap on her face. Going through her morning ritual, she washed her face, brushed her teeth, followed by a liberal amount of mouthwash, then showered and shampooed her hair. The clock on a table in the dressing room chimed the hour. It was nine o’clock, and that meant she had the house to herself. Abigail and Connor were probably boarding their bus that would take them to a private school, while Paige was settling into her second-period class at a nearby high school.")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After slathering her body with a scented moisturizer, Bethany walked back into her bedroom to get dressed. She didn’t have to think about what she would wear, because it was always the same: a matching set of underwear, white T, fitted jeans and running shoes. There had been a time before she’d married Damon that jeans and running shoes were relegated to weekends. But that was when she’d worked as a news correspondent.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wasn’t complaining, because she’d traded her career for marriage and motherhood, but Bethany couldn’t have predicted she would become a stepmother to a surly, impudent teenage girl. Walking out of the bedroom, she made her way down the carpeted hallway to the back staircase that provided direct access to the gourmet kitchen, pantry and the housekeeper’s one-bedroom apartment. Mrs. Rodgers had become an invaluable addition to the family, because her presence allowed Bethany the freedom to make and keep appointments that coincided with her children getting off the bus at the end of a school day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There were two things Damon had insisted on: she would become a stay-at-home mother and she had to be home in time to meet their children’s school bus. She was still a stay-at-home mom, but Mrs. Rodgers filled in for her whenever she wasn’t there when her children came home from school.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("Entering the kitchen, Bethany went completely still when ")]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("she saw Paige sitting at the table in the breakfast nook flipping the pages of a magazine. “What are you still doing here?” The question had come out harsher than Bethany wanted it to.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Paige Paxton’s head popped up, her cold blue gaze raking her stepmother’s too-perfect face like a bird’s talons. Even with no makeup, wet hair, jeans and a T her father’s trophy wife was stunning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The teenager’s thin upper lip curled into a sneer. “If you’d put my school calendar up like you do Connor’s and Abigail’s, you would’ve known that I don’t have classes today. The teachers have staff development today and tomorrow.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I would have put it up if you’d given it to me,” Bethany countered, walking into the kitchen and over to the coffeemaker. She turned it on and placed a pod into the well.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Paige made a clucking sound with her tongue. “What-eva,” she drawled.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Resting a hip against the counter, Bethany crossed her arms under her breasts. “Are you or aren’t you going to give me your calendar?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll think about it.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Spots of color dotted Bethany’s cheeks. “What’s there to think about, Paige?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Paige’s gaze went back to the magazines with photos of models wearing incredible clothes—clothes the girls at her school wore when they didn’t have to wear the regulation uniform of a charcoal-gray pleated skirt, matching knee socks, white blouse with a red tie and navy blazer. “I think I want to be homeschooled.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bethany froze for the second time in a matter of minutes. “Where is this coming from, Paige? I thought you liked your school.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m surprised you even think. I was under the impression the only thing you know how to do is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fuck!")]), _vm._v("”")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("An audible gasp escaped Bethany’s parted lips as she took a step and then stopped herself before she could launch herself across the space separating her from the girl. Her hands curled into tight fists. “If you ever utter that word in my presence again I’ll make certain you’ll never spend another night under this roof.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Paige’s eyes narrowed as she pushed to her feet. “I don’t think so. This is my father’s house.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Wrong, Paige. This is also my house, and don’t forget I did you a favor when I told your father you could come and live here because you didn’t want to move to Idaho. Disrespect me again and you’re outta here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A wave of color suffused Paige’s face, which appeared more pale than it actually was because of the inky-black hair she’d inherited from her mother. “I don’t have to talk to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Then don’t,” Bethany retorted as she struggled to control her rising temper. Connor and Abigail had never argued or fought with each other until their older sister had come to live with them. Now the bickering was nonstop. “If you don’t want to live here, then I’ll talk to your father about sending you back to your mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t want to live with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You don’t want to live with her, and you don’t want to live with me. I suggest you make up your mind, because right now I can’t see you celebrating your sweet sixteen here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rolling her eyes, Paige flopped back down to the cushioned bench seat. “What do you want from me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“An apology will do,” Bethany said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You want me to tell you I’m sorry even when I don’t mean it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Resting her hands at her waist, Bethany stared at Damon’s eldest child. “Maybe I just need to hear it even if you’ll never mean it.”")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There came a beat. “Okay…I’m sorry. There. I’ve said it,” Paige spat out.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Apology accepted.” Bethany decided to extend the olive branch because going toe-to-toe with the child was wearing her down. “I was going to make breakfast for myself. Would you like me to fix something for you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do I look like I need to eat?” Paige snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“If you think you’re going to lose weight by not eating, then you’re taking the wrong approach,” she told Paige as she opened the built-in refrigerator and took out a carton of eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She knew some of the girl’s hostility was because of body image. Paige had stopped growing after hitting a height of five-three. Although her parents were both tall and slim, she had yet to lose what one would refer to as baby fat. Her best features were her eyes and hair. And except for an occasional breakout, her skin was as clear as bone china. Bethany had overheard Paige asking Damon if she could get a nose job and liposuction. He’d promised her she could get her nose fixed for her sixteenth birthday but had drawn the line at liposuction. His comeback was that if she exercised more then she would not only lose weight but also keep it off.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“FYI…I lost two pounds last week eating salads.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What kind of salads?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lettuce.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Lettuce and what?” Bethany asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Just lettuce with light Italian dressing.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Opening the refrigerator again, Bethany took out the ingredients for a veggie omelet. “What about fruit, vegetables or protein?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What about them?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You need them for a balanced diet.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Meat makes me fat.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Bethany diced an onion, pepper and several mushrooms. ")]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("“You’re not fat, Paige. What you need to do is tone your body. You can come with me when I work out with my trainer.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll think about it,” Paige mumbled. She wasn’t about to give Bethany the satisfaction of agreeing with her. She would never have her stepmother’s tall, willowy body, but knew she would look better without the additional twenty pounds she’d put on after her mother told her she was going to marry the man who’d once been her landscaper before he’d become her lover. What had frightened Paige was that the man had made sexual innuendos to his employer’s daughter the year she turned twelve. At first she’d believed she’d imagined his intent, but the one time he walked into her bedroom while she was getting dressed confirmed her suspicions that he was a predator. There was no way she was going to live with her mother, even if she still blamed Bethany for breaking up her parents’ marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you certain you don’t want an omelet?” Bethany asked, breaking into Paige’s musing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Is it fattening?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bethany smiled. “No. I doubt if it’s more than fifty calories. And that includes cooking it with a nonstick butter-flavored cooking spray.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Okay. I’ll have one.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("Not wanting to believe she’d scaled a small hurdle, Bethany cut up enough vegetables for two omelets. She squeezed oranges for juice and toasted two slices of all-grain bread. She wasn’t certain if Paige would eat the bread, but she decided to offer it to her anyway. She’d been where Paige was now—yoyo dieting that had compromised her health when she experienced horrific headaches and fainting spells. A nutritionist taught her what to eat to lose and then maintain her weight, while a personal trainer put her through an exercise regimen ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("that toned and reconfigured her body until she looked as if she’d been nipped and tucked—even after two children.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bethany was aware that she was a trophy wife, and she planned to look the part for as long as she could. The wives of Damon’s associates had not accepted her, but she wasn’t going to give the jealous women the satisfaction of knowing how much their rejection had affected her. The few times she’d found herself in their presence she’d made certain to look her best. The saying was that revenge was best served cold, but for Bethany it was looking hot. So hot that their husbands couldn’t stop staring at her. And if she had been the bitch everyone thought she was, then she would have slept with each of the men, then reported back to their wives on their performances—or lack thereof.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bethany and Paige ate without talking, only the sound of music coming from a stereo unit on the counter breaking the uncomfortable silence. There was so much she wanted to talk about with Paige, but she decided to enjoy their unexpected and no doubt temporary truce. She was only twenty years older than the girl and had wanted to relate to her not as a mother but as an older sister.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bethany had never been on good terms with her two sisters because they’d always resented her ambition to escape the predictable existence if she’d remained in the tiny town where everyone knew one another. Alice and Mary-Beth stayed, married local boys and continued the cycle of working for the mill or in the newly constructed Walmart. Her younger brother did get out when he joined the Marines as a reservist, but after two tours in Iraq had moved to Alaska where he’d married and fathered three children in five years. It had been more than four years since Bethany had gotten a letter from him. Her letters to him had been returned with a stamp indicating addressee unknown.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her parents had stopped talking to her when she told them she couldn’t send them any more money, so that left just her and her twin. Jack was kind, gentle, but easily misled. He’d been arrested so many times for petty crimes that the local sheriff would lock him up for his own safety. Although Jack hadn’t been able to stay out of trouble he had become Bethany’s voice of reason. Whenever she needed someone to listen without passing judgment, Jack was there. Whenever she felt as if she was at her wit’s end, Jack was able to give her another perspective. When he’d told her that nothing or no one was worth her losing her freedom she’d thought about what he had gone through whenever he was locked up. The one time he’d admitted that another prisoner had sexually abused him, Bethany had cried for days. Then she’d called the sheriff to tell him if he had to lock up her brother, to please not put him in a cell with another prisoner. If the sheriff had been anyone but the boy who’d been homecoming king while she was his homecoming queen he would’ve hung up on her. She and Lenny Mortimer had dated during their last year in high school, and although many thought they would eventually marry Bethany knew differently. She’d sworn an oath when she’d received notification that she had been granted an academic scholarship to attend the University of Virginia that she would never return to Parkers Corner to live.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Are you serious about wanting to be homeschooled?” she asked Paige, who’d eaten half her omelet before setting down her fork.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Have you spoken to your father about it?” Paige nodded. “What did he say?” Bethany asked, continuing with her questioning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He said I would have to talk to you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pale eyebrows lifted a fraction. “Why me?”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A hint of smile played at the corners of Paige’s mouth. “Because you would have to be my teacher.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bethany’s mouth opened and closed several times. “You’re kidding.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nope. Who else did you think would teach me?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m not a teacher, Paige.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But you did graduate college, didn’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, I did. But that still doesn’t mean I would be the best candidate to teach you chemistry, algebra and trigonometry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Paige smiled. “That’s what teachers’ guides are for.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“That’s where you’re wrong, Paige. I have enough to do when I check and help Abby and Connor with their homework. There’s no way I’m going to spend five hours a day teaching and tutoring you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What the hell else do you have to do all day?” Paige shouted. “You have someone come in twice a week to clean the house and do laundry. Miss Rodgers does everything else. So why can’t you become my teacher?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Because I am "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not")]), _vm._v(" a teacher.” Bethany had punctuated each word. “I majored in English and communications, not math and science.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Maybe I should tell Daddy that you don’t want to homeschool me because I’m not your daughter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I don’t give a damn what you tell him. I’m not going to homeschool you when you’re enrolled in one of the best private schools in Virginia and—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Paige put up her hand, stopping Bethany’s tirade. “Daddy told me he’s going to talk to you about it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("Rising to her feet, Bethany glared down at the manipulative girl. There was nothing to talk about. She had no intention of homeschooling Paige when Damon spent what amounted to a small fortune for her tuition. If Paige had planned to come between her and Damon, then she was ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("fighting hard to make it a reality. As much as she loved her husband, Bethany had made up her mind to risk her marriage rather than be manipulated by a malcontent, rebellious and jealous adolescent.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leaning closer, she narrowed her eyes. “There is nothing to talk about.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Reaching over, Bethany picked up Paige’s plate and emptied the contents in the trash. She left the dishes in the sink for Mrs. Rodgers to put in the dishwasher, then went to get her coat, purse and car keys. She had to get out of the house before she did or said something she would later regret.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bethany did not glance up from the book she was reading when Damon walked into the bedroom, closing and locking the door behind him. He’d called earlier to let her know he would not join the family for dinner. He’d had a dinner meeting with the junior senator from Wisconsin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked up and smiled. At fifty-four, Damon Pennington Paxton had movie-star looks. His close-cropped light brown hair was sprinkled with silver, and he had tiny, attractive lines around large, deep-set dark blue eyes that were mesmerizing whenever he smiled. Damon held a powerful position in D.C., and whenever elected officials were told Damon was on the phone, his call was promptly answered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hey, yourself,” she said. Rising off the window seat, Bethany approached him. Wrapping her arms around his waist, she pressed her breasts to his chest. “How was your day?” It was the same thing she asked him every day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It could’ve been better,” he said, his soft Southern drawl caressing her ear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What’s wrong, sweetheart?” she crooned, her hand massaging her husband’s back over his shirt.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Paige called me at the office, crying that you won’t homeschool her because you hate her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Easing back, Bethany met Damon’s eyes. “That’s not true, and you know it, Damon. If I hated her, then I never would’ve agreed to have her come here to live. When I spoke to Jean about Paige coming here to live with us, she was upset because she didn’t want to lose her daughter. I reassured her I would treat Paige no differently than I would Abby or Connor, but it hasn’t been easy. She fights with me about everything.” Bethany then informed him that Paige had disrupted what had been a peaceful household to one where the younger children were now fighting with each other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Why didn’t you tell me about this before?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bethany closed her eyes, and when she opened them she saw something in her husband’s eyes that hadn’t been there before—anger. “I thought I’d be able to deal with her.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“There’s no way you could deal with her, Beth! She’s my daughter, not yours, so it’s my responsibility to deal with her. You don’t need to be involved when it concerns my child.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The frustration that had been building inside Bethany for the past four months felt like gall in her mouth; she dropped her arms and took a step backward. “So, it’s going to be your child and my children!” she screamed. “What do I do, Damon? Let her verbally abuse me, then say wait until your father gets home? I’m sorry, but it’s not going to go down that way. I’m tired of being nice to her out of respect for you. You better tell your daughter that she’d better take her ass to that fancy school you pay twenty gees for, because I wouldn’t help her add two and two.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("Turning on her heel, Bethany walked out of the bedroom and into one of the guest suites. Falling across the bed, she did what she hadn’t done in years. She cried. She cried until her sobs became hiccuping sounds before she slept from emotional ")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("exhaustion. It would be the first night since she had seduced Damon Paxton that they would sleep under the same roof, but not in the same bed.")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  })]), _c('a', {
    attrs: {
      "id": "page24"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page24"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb732a3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459215382_ch01.vue
// module id = 72
// module chunks = 0